/**
 * @Author: Zewei
 * @Date:   2018-02-11T10:48:06+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-14T10:00:09+08:00
 */

import _util from '../../utils/';

const userGroupService = {
    fetchUserGroupList(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    createUserGroupList(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    addGroupTemplate(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportGroupTemplate/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateGroupTemplate(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportGroupTemplate/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteUserGroupList(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteUserGroupTemplateList(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportGroupTemplate/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateUserGroupList(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    fetchUserGroupDetail(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/Details',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchGroupTemplateAll(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportReviewGroup/groupTemplates',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchUserGroupTemplateList(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportGroupTemplate/Details',
            params: params,
            success: resolve,
            error: reject
        })
    },
    // fetchWorkReportInit(params, resolve, reject) {
    //     _util.request({
    //         url: '/api/HRWorkReport/Post',
    //         params: params,
    //         success: resolve,
    //         error: reject
    //     })
    // },
}



export default userGroupService;



// WEBPACK FOOTER //
// ./src/services/DailyReport/user-group-service.js